/* Hämtar och lagrar orduppställningar. */
import Storage from './Storage';

async function fetchBoard(nr, seed) {
    const controller = new AbortController();
    const id = setTimeout(() => { controller.abort() }, 4000);
    const url = `https://kjell.haxx.se/nian/nian.cgi?antal=${nr}&seed=${seed}`;
    const today = new Date().toISOString().split("T")[0];

    return await fetch(
        url,
        {
            signal: controller.signal
        })
        .then(res => res.json())
        .then(
            (result) => {
                clearTimeout(id);
                return ({
                    result: { ...result, "_date": today },
                    error: null
                });
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                return ({
                    result: null,
                    error: error
                });
            }
        ).catch(function (e) {
            console.error("catch", e.message);
            return ({
                result: null,
                error: e.message
            });
        });
}

function todaySeed(nr) {
    let seed = Math.trunc(Date.now() / (24 * 3600 * 1000)) * 10 + nr; // Todays seed
    return (seed);
}

export default class BoardHandler {
    static async getBoard(nr, random) {
        let seed = todaySeed(nr);
        let boards = Storage.get("boards");
        if (!random) {
            let brd = boards["today"][nr];
            if (brd && brd["seed"] === seed) {
                return ({ result: brd });
            }
        }
        if (navigator.onLine) {
            if (random) {
                seed = Math.trunc(Math.random() * Number.MAX_SAFE_INTEGER);
            }
            let { result, error } = await fetchBoard(nr, seed);
            if (result) {
                console.log("return ok");
                if (!random) {
                    boards["today"][nr] = result;
                    Storage.set("boards", boards);
                }
                return { result };
            }
            // Find cached variant
            let brd = boards["random"][nr];
            if (brd) {
                boards["random"][nr] = undefined;
                Storage.set("boards", boards);
                return ({ result: brd });
            }
            return { error };
        }
        return { error: "offline" };
    }

    static async fillCache(sizes) {
        let boards = Storage.get("boards");
        let addrandom;
        let addtoday;
        if (boards == null) {
            boards = {
                today: {},
                random: {}
            };
        }

        sizes.forEach((nr) => {
            let todayseed = todaySeed(nr);
            {
                let brd = boards["today"][nr];
                if (!brd || brd.seed !== todayseed) {
                    boards["today"][nr] = undefined;
                    addtoday = nr;
                }
            }
            {
                let brd = boards["random"][nr];
                if (!brd) {
                    addrandom = nr;
                }
            }
        })
        if (addtoday) {
            let nr = addtoday;
            let todayseed = todaySeed(nr);
            let { result } = await fetchBoard(nr, todayseed);
            if (result) {
                boards["today"][nr] = result;
                boards = Storage.set("boards", boards);
            }
        } else if (addrandom) {
            let nr = addrandom;
            let seed = Math.trunc(Math.random() * Number.MAX_SAFE_INTEGER);
            let { result } = await fetchBoard(nr, seed);
            if (result) {
                boards["random"][nr] = result;
                Storage.set("boards", boards);
            }
        }
    }
}
